export default __webpack_public_path__ + "static/media/Post-Listing-Microsite-NotListed-Blocks-10.f582fe2a.png";